module.exports = __webpack_public_path__ + "static/media/goal.228a6f1c.png";